import AnswerContentGenerator from './AnswerContentGenerator';

export default AnswerContentGenerator;
